import basket1 from "../../../assets/plate.webp";
import basket2 from "../../../assets/thali.webp";
import basket3 from "../../../assets/cutlery.webp";
import basket4 from "../../../assets/grain-trolly.webp";
import basket5 from "../../../assets/sheet-cutlery-box.webp";
import basket6 from "../../../assets/sheet-cutlery.webp";
import basket7 from "../../../assets/partition-basket.webp";
import basket8 from "../../../assets/vegetable-basket.webp";
import basket9 from "../../../assets/bottel-basket.webp";
import basket10 from "../../../assets/glass-basket.webp";
import basket11 from "../../../assets/carousel-3&4.webp";
import basket12 from "../../../assets/dee-tray.webp";
import basket13 from "../../../assets/bottle-pullout-2-shelves.webp";
import basket14 from "../../../assets/stainless-steel-304-bottle-pullout.webp";
import basket15 from "../../../assets/gtpt-wire.webp";
import basket16 from "../../../assets/single-self.webp";
import basket17 from "../../../assets/glass-holder-basket.webp";
import basket18 from "../../../assets/hanging-corner-single-shelf.webp";
import basket19 from "../../../assets/hanging-corner-2-Shelf.webp";
import basket20 from "../../../assets/triple-shelf.webp";
import basket21 from "../../../assets/spoone-holder.webp";
import basket22 from "../../../assets/kitchens-keeper.webp"
import basket23 from "../../../assets/laddlecraddle.webp";
import basket24 from "../../../assets/bucket-bin.webp";
import basket25 from "../../../assets/use-me-shutter.webp";
import basket26 from "../../../assets/cylinder-trolley.png";
import basket27 from "../../../assets/bin-holder.webp";

const kitchensBasketData = [
  {
    id: 1,
    name: "Plate Basket",
    image: basket1,
    description: "Premium modular plate basket for organized, space-saving kitchens. Durable, stylish, and practical, keeps plates secure, accessible, and neatly arranged for daily use."
  },
  {
    id: 2,
    name: "Thali Basket",
    image: basket2,
    description: "Premium modular thali basket for organized kitchens. Durable and space-saving design keeps your plates and thalis neatly arranged, secure, and easily accessible for daily use."
  },
  {
    id: 3,
    name: "Cutlery Wire Basket",
    image: basket3,
    description: "Durable cutlery wire basket for organized kitchens. Keeps forks, spoons, knives neatly arranged, easily accessible, and saves space efficiently."
  },
  {
    id: 4,
    name: "grain Trolly",
    image: basket4,
    description: "Durable modular grain trolley for kitchen storage. Organizes rice, pulses, and grains neatly, easily accessible, and saves space efficiently."
  },

   {
    id: 5, 
    name: "Cutlery Perforated",
    image: basket5,
    description: "Keep your kitchen cutlery organized and accessible with this durable perforated basket. Designed for forks, spoons, and knives, it allows airflow to keep items dry, neat, and hygienic."
  },

   {
    id: 6,
    name: "Cutlery Box",
    image: basket6,
    description: "Durable modular cutlery box for organized kitchens. Keeps forks, spoons, knives neatly arranged, easily accessible, and ensures a clutter-free, space-saving countertop or drawer."
  },

  {
    id: 7,
    name: "Partition Basket",
    image: basket7,
    description: "Modular partition basket for organized kitchens. Separates utensils, plates, and cutlery neatly, saves space, and keeps items easily accessible and tidy in cabinets or drawers."
  },
  {
    id: 8,
    name: "Vegetable Basket",
    image: basket8,
    description: "Durable modular vegetable basket for kitchens. Keeps vegetables organized, ventilated, and easily accessible, helping maintain freshness while saving space in cabinets or countertops."
  },

   {
    id: 9,
    name: "Bottle Basket ",
    image: basket9,
    description: "Sturdy modular bottle basket for organized kitchens. Keeps bottles upright, secure, and easily accessible while saving space in cabinets, shelves, or countertops."
  },
  {
    id: 10,
    name: "Glass Basket ",
    image: basket10,
    description: "Durable modular glass basket for organized kitchens. Keeps glasses safe, neatly arranged, and easily accessible while saving space and preventing breakage in cabinets."
  },
  {
    id: 11,
    name: "Carousel (3/4)",
    image: basket11,
    description: "Efficient 3/4 carousel unit for corner kitchens. Maximizes storage, provides easy access, and smoothly rotates to organize utensils and kitchen essentials neatly."
  },
   {
    id: 12,
    name: "Dee Tray",
    image: basket12,
    description: "Smart Dee tray for corner kitchens. Maximizes storage, provides smooth access, and keeps utensils and essentials neatly organized in hard-to-reach spaces."
  },
  {
    id: 13,
    name: "Bottle Pull Out 2 Shelf",
    image: basket13,
    description: "Compact and durable bottle pull-out with two shelves, designed for modular kitchens. Keeps bottles neatly organized, secure, and easily accessible while maximizing cabinet space efficiently."
  },

   {
    id: 14,
    name: "Bottle Pull Out 3 Shelf",
    image: basket14,
    description: "Spacious and durable bottle pull-out with three shelves, ideal for modular kitchens. Keeps bottles well-organized, secure, and easily accessible while maximizing cabinet storage efficiently."
  },
   {
    id: 15,
    name: "GTPT Wire",
    image: basket15,
    description: "High-quality GTPT wire for modular kitchen baskets. Strong, rust-resistant, and durable, ensures long-lasting performance and supports efficient, organized kitchen storage solutions."
  },
  {
    id: 16,
    name: "Hanging Corner",
    image: basket16,
    description: "Space-saving hanging corner unit for modular kitchens. Utilizes unused corners efficiently, keeps essentials organized, and provides easy access with a smart, modern design."
  },
{
    id: 17,
    name: "Glass Holder",
    image: basket17,
    description: "Durable glass holder for modular kitchens. Keeps glasses secure, neatly arranged, and easily accessible while saving space and preventing damage or breakage."
  },
{
    id: 18,
    name: "Single Shelf",
    image: basket18,
    description: "Sturdy single shelf for modular kitchens. Provides simple, space-saving storage, keeping essentials neatly arranged, easily accessible, and organized for everyday use."
  },
  {
    id: 19,
    name: "Double Shelf",
    image: basket19,
    description: "Durable double shelf for modular kitchens. Offers extra storage space, keeps items neatly organized, easily accessible, and maximizes cabinet efficiency for everyday use."
  },

    {
    id: 20,
    name: "Triple Shelf",
    image: basket20,
    description: "Spacious triple shelf for modular kitchens. Maximizes vertical storage, keeps items neatly organized, easily accessible, and improves overall cabinet efficiency for daily use."
  },

    {
    id: 21,
    name: "Spoon Holder",
    image: basket21,
    description: "Compact spoon holder for modular kitchens. Keeps spoons neatly organized, easily accessible, and maintains hygiene while saving space in drawers or countertops."
  },

   {
    id: 22,
    name: "kitchen Keeper",
    image: basket22,
    description: "Multi-purpose kitchen keeper for organized storage. Keeps essentials neatly arranged, easily accessible, and helps maintain a clean, clutter-free and efficient kitchen space."
  },

   {
    id: 23,
    name: "Laddle Craddle",
    image: basket23,
    description: "Convenient ladle cradle for modular kitchens. Holds ladles and spoons while cooking, keeps countertops clean, and prevents spills or mess during food preparation."
  },
  {
    id: 24,
    name: "Bucket Bin",
    image: basket24,
    description: "Durable bucket bin for kitchen waste management. Keeps garbage organized, hygienic, and concealed, while saving space and ensuring easy disposal in modular kitchens."
  },

   {
    id: 25,
    name: "Use Me Shutter",
    image: basket25,
    description: "Smart “Use Me” shutter for modular kitchens. Provides quick access storage, keeps essentials hidden yet accessible, and enhances a clean, modern kitchen look."
  },
  {
    id: 26,
    name: "Cylinder Trolly",
    image: basket26,
    description: "Sturdy cylinder trolley for easy gas cylinder movement. Provides smooth mobility, stable support, and keeps your kitchen safe, organized, and convenient for daily use."
  },

  {
    id: 27,
    name: "Bin  Holder",
    image: basket27,
    description: "Sturdy bin holder for modular kitchens. Keeps waste bins securely in place, easily accessible, and helps maintain a clean, organized, and hygienic kitchen space."
  },
];

export default kitchensBasketData;